import { gql } from "@apollo/client";

export const QUERY_MEETING_METRICS_REPORT = gql`
  query (
      $schoolIds: [ID], 
      $selectedFields: [String],
    ) {
    meetingMetricsReport(
      schoolIds: $schoolIds, 
      selectedFields: $selectedFields
    ) {
      success
      message
      reportDataJson
    }
  }
`;
